// @flow
import { Box, useTheme } from '@mui/material';
import * as React from 'react';

/**
 * SOE Status Icons
 * 
 * @param props
 * @return {XML}
 */
const SoeStatus = (props) => {
  const theme = useTheme();
  const { status, size = '24px', style, title, ...rest } = props;
  const purple = theme.palette.purple.main;
  const grey = '#bdbdbd';

  // SOE identified: solid purple border, transparent background, purple S
  if (status === 'identified') {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          border: `1.5px solid ${purple}`,
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '15px',
          color: purple,
          fontWeight: 700,
        }}
        style={style}
        title={title}
        {...rest}
      >
        S
      </Box>
    );
  }

  // Not SOE: solid grey border, transparent background, grey S
  if (status === 'not_soe') {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          border: `1.5px solid ${grey}`,
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '15px',
          color: grey,
          fontWeight: 700,
          opacity: 0.8,
        }}
        style={style}
        title={title}
        {...rest}
      >
        <span>S</span>
      </Box>
    );
  }

  return null;
};

export default SoeStatus; 